import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CreatePromocodeModal, EditPromocodeModal, PromocodeListFilters } from "@modules/promocodes/components";

import { usePromocodesList } from "./controller";
import { usePromocodesListColumns } from "./columns";

export const PromocodeList = React.memo(() => {
  const {
    rows,
    loading,
    agreements,
    bachs,
    selectedRows,
    dataToExport,
    createPromocodeModalRef,
    editPromocodeModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } =  usePromocodesList();

  const columns = usePromocodesListColumns(
    refetch,
    translate,
    editPromocodeModalRef,
    agreements,
    bachs,
  );


  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <PromocodeListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="promocodes.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createPromocodeModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreatePromocodeModal
        modalRef={createPromocodeModalRef}
        onComplete={refetch}
      />
      <EditPromocodeModal
        modalRef={editPromocodeModalRef}
        onComplete={refetch}
      />
    </List>
  );
});
